import { Box, Typography } from "@mui/material"
import Iconify from "minimals-template/components/Iconify"

const TYPE_COLORS = {
    info: "text.secondary",
    success: "success.main",
    warn: "warning.main",
}

const TYPE_ICONS = {
    info: "mdi:information-outline",
    success: "mdi:check-circle-outline",
    warn: "mdi:alert-outline",
}

export function CopImportProgressMessage({ item }) {
    const color = TYPE_COLORS[item.type] ?? TYPE_COLORS.info
    const icon = TYPE_ICONS[item.type] ?? TYPE_ICONS.info

    const timestamp = item.time ? formatTime(item.time) : ""

    return (
        <Box sx={{ display: "flex", alignItems: "flex-start", gap: 0.5, py: 0.2 }}>
            <Typography
                variant="caption"
                sx={{ color: "text.disabled", fontFamily: "monospace", flexShrink: 0, mt: 0.1 }}
            >
                {timestamp}
            </Typography>
            <Iconify icon={icon} sx={{ color, fontSize: 14, mt: 0.2, flexShrink: 0 }} />
            <Typography variant="caption" color={color}>
                {item.message}
            </Typography>
        </Box>
    )
}

function formatTime(date) {
    return date.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit", second: "2-digit" })
}
